import axios from 'axios';

// Determine the correct base URL based on the environment
let baseURL = '/api';

// If we're on the production domain, use the full URL
if (window.location.hostname === 'www.tideasolis.com' || window.location.hostname === 'tideasolis.com') {
  // Use the API endpoint on the same domain
  baseURL = '/api';
  
  // If API is actually on a subdomain (but it seems it's not):
  // baseURL = 'https://api.tideasolis.com/api';
} 

// Apply once, before the rest of your app is imported
axios.defaults.baseURL = baseURL;
axios.defaults.headers.post['Content-Type'] = 'application/json';

// API token management
let apiToken = null;
let tokenExpiry = null;

// Helper to check if token is expiring soon (2 min buffer)
function isTokenExpiring() {
  if (!tokenExpiry) return true;
  return new Date(tokenExpiry) < new Date(Date.now() + 2 * 60 * 1000);
}

// Debug function to check token validation
async function checkTokenValidation() {
  try {
    const response = await axios.get('/debug/token-check', {
      headers: {
        'X-API-Token': apiToken
        // Don't set Origin header manually, browser will handle it
      }
    });
    
    // console.log('Token validation debug:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error checking token validation:', error);
    return null;
  }
}

// Request interceptor for auth token and API token
axios.interceptors.request.use(
  async config => {
    // Skip API token for the token endpoint itself to avoid infinite loop
    if (config.url === '/bookings/api-token' || config.headers['Skip-Auth-Interceptor']) {
      return config;
    }
    
    // Get API token or refresh if needed
    if (!apiToken || isTokenExpiring()) {
      try {
        // Get the current origin for the token - commented out, browser will set it automatically
        // const origin = window.location.origin;
        
        // Create a clean axios call to avoid interceptor loop
        const tokenResponse = await axios.post('/bookings/api-token', {}, {
          headers: { 
            'Skip-Auth-Interceptor': 'true'
            // Origin header is automatically set by browser, don't set manually
          }
        });
        
        if (tokenResponse.data && tokenResponse.data.token) {
          apiToken = tokenResponse.data.token;
          tokenExpiry = tokenResponse.data.expires_at;
          console.log('New API token acquired');
          
          // Check token validation after getting a new token (debug only)
          // setTimeout(checkTokenValidation, 500);
        }
      } catch (error) {
        console.error('Failed to get API token:', error);
      }
    }
    
    // Don't manually set Origin - browser will set it automatically
    // const origin = window.location.origin;
    // config.headers['Origin'] = origin;
    
    // Add API token to headers if available
    if (apiToken) {
      config.headers['X-API-Token'] = apiToken;
    }
    
    // Get token from localStorage if it exists (keep existing auth code)
    const token = localStorage.getItem('token');
    
    // If token exists, add to headers
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    // Debug: Log request headers
    // console.log(`Request to ${config.url}:`, {
    //   hasApiToken: !!config.headers['X-API-Token'],
    //   apiTokenLength: config.headers['X-API-Token'] ? config.headers['X-API-Token'].length : 0,
    //   hasAuthToken: !!config.headers.Authorization,
    //   headers: config.headers
    // });
    
    return config;
  },
  error => Promise.reject(error)
);

// Export the debug function
export { checkTokenValidation };

// Response interceptor for handling errors
axios.interceptors.response.use(
  r => r,
  err => {
    // Only log critical errors to avoid console noise
    if (err?.response?.status >= 500) {
      console.error('API server error:', err?.response?.status);
      // Add error response details for debugging critical issues
      if (err.response && err.response.data) {
        console.error('Error details:', err.response.data);
      }
    }
    return Promise.reject(err);
  },
); 